import styled from "styled-components";

// export const LayoutWrapper = styled.div`
//   max-width: 700px;
//   margin: 0 auto;
//   padding: 2rem 1rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   background-color: #a3c9eb;
//   border-radius: 15px;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
// `;

// OPÇÃO 1: Transparência com glassmorphism (RECOMENDADO)
// export const LayoutWrapper = styled.div`
//   width: 100%;
//   max-width: 700px;
//   margin: 0 auto;
//   padding: 2rem 1rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;

//   /* Glassmorphism - efeito vidro moderno */
//   background: rgba(255, 255, 255, 0.1);
//   backdrop-filter: blur(10px);
//   border: 1px solid rgba(255, 255, 255, 0.2);
//   border-radius: 20px;
//   box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
// `;

// OPÇÃO 2:
// export const LayoutWrapper = styled.div`
//   width: 100%;
//   max-width: 700px;
//   margin: 0 auto;
//   padding: 2rem 1rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;

//   background: linear-gradient(
//     135deg,
//     rgba(218, 91, 255, 0.2) 0%,
//     rgba(59, 0, 104, 0.3) 100%
//   );
//   backdrop-filter: blur(8px);
//   border-radius: 20px;
//   box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
//   border: 1px solid rgba(255, 255, 255, 0.1);
// `;

// OPÇÃO 3:
// export const LayoutWrapper = styled.div`
//   width: 100%;
//   max-width: 700px;
//   margin: 0 auto;
//   padding: 2rem 1rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;

//   background: rgba(0, 0, 0, 0.4);
//   backdrop-filter: blur(12px);
//   border-radius: 20px;
//   box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
//   border: 1px solid rgba(255, 255, 255, 0.15);
// `;

// OPÇÃO 4:
export const LayoutWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: rgba(59, 0, 104, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(218, 91, 255, 0.2);
  border: 1px solid rgba(218, 91, 255, 0.3);

  @media screen and (max-width: 768px) {
    max-width: 100%;
    /* margin-top: 15rem; */
  }
`;

// OPÇÃO 5:
// export const LayoutWrapper = styled.div`
//   width: 100%;
//   max-width: 700px;
//   margin: 0 auto;
//   padding: 2rem 1rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;

//   background: rgba(255, 255, 255, 0.05);
//   backdrop-filter: blur(5px);
//   border-radius: 20px;
//   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
//   border: 2px solid rgba(255, 255, 255, 0.1);
// `;
